<template>

	<div  class="tabWrapper wrapUserTabStatements">
		<div class="main">
			<div v-if="isDispatchHead || isSalesManager || isSalesHead || isSafetyHead" class="main">
				<statements-manager
						:user="user"
				></statements-manager>
			</div>
			<div v-else-if="isSafety" class="main">
				<statements-safety
						:id="id"
						:user="user"
				></statements-safety>
			</div>
			<div
					v-else-if="isDispatch"
					class="main"
			>
				<statements-dispatch
						:id="id"
				></statements-dispatch>
			</div>
<!--			<div-->
<!--					v-else-if="isDispatchAltex"-->
<!--					class="main"-->
<!--			>-->
<!--				<statements-all-->
<!--						v-if="id"-->
<!--						:id="id"-->
<!--						:user="user"-->
<!--						is-general-title-->
<!--				></statements-all>-->
<!--			</div>-->
			<div v-else class="main">
				<statements-all
						v-if="id"
						:id="id"
						:user="user"
						is-general-title
				></statements-all>
			</div>

		</div>
	</div>
</template>

<script>

import { mapGetters } from "vuex";
import StatementsDispatch from "@/pages/UserProfile/Tabs/Statements/StatementsDispatch.vue";
import StatementsSafety from "@/pages/UserProfile/Tabs/Statements/StatementsSafety.vue";
import StatementsAll from "@/pages/UserProfile/Tabs/Statements/StatementsAll.vue";
import StatementsManager from "@/pages/UserProfile/Tabs/Statements/StatementsManager.vue";

export default {
	name: "UserTabStatements",
	components: {
		StatementsManager,
		StatementsSafety,
		StatementsAll,
		StatementsDispatch

	},
	computed: {
		...mapGetters([
			'userProfileMyInfo',
		]),
	},
	props: {
		user: Object,
	},
	data: () => ({
		id: null,

		isAltex: false,

		isSafety: false,
		isDispatchHead: false,
		isDispatch: false,
		isDispatchAltex: false,
		isAfterhours: false,
		isSalesManager: false,
		isSalesHead: false,
		isSafetyHead: false,
		isHR: false,
		isAccounting: false,
		isSecurity: false,
		isIT: false,
		isFleetAltex: false,
		isHRAltex: false,
		isSafetyAltex: false,
		isOperationAltex: false,
		isFinancialAltex: false,
		isAccountingAltex: false,
		isAdministrationAltex: false,
		isITAltex: false,
	}),
	methods: {

	},
	mounted() {
		const id = this.$route.params.id;

		const {
			department_id,
			dispatcher_id,
			company_id,
		 } = this.user;

		this.isAltex = company_id === 2;

		this.isSafety = department_id === 1;
		this.isDispatchHead = department_id === 2;
		this.isSalesManager = department_id === 3;
		this.isSalesHead = department_id === 4;
		this.isSafetyHead = department_id === 5;
		this.isAfterhours = department_id === 6;
		this.isDispatch = department_id === 7;
		this.isHR = department_id === 8;
		this.isAccounting = department_id === 9;
		this.isSecurity = department_id === 10;
		this.isIT = department_id === 11;
		this.isDispatchAltex = department_id === 12;
		this.isFleetAltex = department_id === 13;
		this.isHRAltex = department_id === 14;
		this.isSafetyAltex = department_id === 15;
		this.isOperationAltex = department_id === 16;
		this.isFinancialAltex = department_id === 17;
		this.isAccountingAltex = department_id === 18;
		this.isAdministrationAltex = department_id === 19;
		this.isITAltex = department_id === 20;

		this.id = this.isDispatch ? dispatcher_id : id;
	}
};
</script>

<style scoped lang="scss"></style>
